import { useMemo } from "react";

import { usePaywallCheckoutContext } from "@/react/contexts/Paywalls/paywallCheckoutContext";

import { isPaymentMethodRequired } from "../../../Attempts/helpers/isPaymentMethodRequired";
import { useGetCouponApplication } from "../../../hooks/useGetCouponApplication";

export const useIsPaymentElementRequired = () => {
  const { paywall, getSelectedPrice, couponPreviewMutation } =
    usePaywallCheckoutContext();

  const selectedPrice = getSelectedPrice();
  const couponApplication = useGetCouponApplication(
    selectedPrice.id,
    couponPreviewMutation,
  );

  return useMemo(
    () =>
      isPaymentMethodRequired({
        doesOfferHaveTrial: selectedPrice.trial_enabled ?? false,
        doesOrderHaveFullForeverDiscount:
          couponApplication?.free_forever ?? false,
        doesTrialRequirePaymentMethod: paywall.trial_requires_card ?? false,
        doesTrialRequireUpfrontPayment:
          selectedPrice.trial_requires_upfront_payment ?? false,
      }),
    [
      couponApplication?.free_forever,
      paywall.trial_requires_card,
      selectedPrice.trial_enabled,
      selectedPrice.trial_requires_upfront_payment,
    ],
  );
};
